import axios from 'axios';
import Loading from 'quasar/src/plugins/loading/Loading.js';import Notify from 'quasar/src/plugins/notify/Notify.js';
import { authStore } from "@/store/auth.store";
import router from '../router/index.js';
import { basicStore } from "@/store/basic.store";



export async function loginAction(id,password){

  try {

    await Loading.show()

    const store = authStore()
    const store2 = basicStore()

    const user = await axios.post(`${store2.host}/api/v1/clients-auth/login`,{
      id,
      password,
    })

    user.data.data.formalPersonalPhoto = `${store2.host}/${user.data.data.formalPersonalPhoto}`

    await localStorage.setItem('user', JSON.stringify(user.data.data));
    store.user = await user.data.data
    await Loading.hide()
    Notify.create({
      type:"positive",
      message:"تم تسجيل الدخول بنجاح"
    })
    await router.push("/home")
  }
  catch (e) {
    await Loading.hide()
    Notify.create({
      type:"negative",
      message:"برجاء التاكد من رقم الحساب"
    })
    await localStorage.removeItem("user")
    // console.log(e.response.data.message)
  }

}



export async function chackLoginAction(password){

  try {

    const store = authStore()
    const store2 = basicStore()

    const user = await axios.post(`${store2.host}/api/v1/clients-auth/login`,{
      id:store.user.id,
      password,
    })

    user.data.data.formalPersonalPhoto = `${store2.host}/${user.data.data.formalPersonalPhoto}`

    await localStorage.setItem('user', JSON.stringify(user.data.data));
    store.user = await user.data.data
  }
  catch (e) {
    localStorage.removeItem("user")
    await router.push("/")
    console.log(e.response.data.message)
  }

}



export async function logoutAction(){

  try {

    const store = authStore()

    await localStorage.removeItem('user');
    store.user = {
      id:"",
      password: "",
      employee: {
        id: "",
        name: "",
        section: "",
        category: "",
        specialization: "",
        formalPersonalPhoto: ""
      }
    }
    await router.push("/")
    Notify.create({
      type:"positive",
      message:"تم تسجيل الخروج بنجاح"
    })
  }
  catch (e) {
    console.log(e.message)
  }

}


export async function changePasswordAction(data){

  try {

    await Loading.show()

    const store = authStore()
    const store2 = basicStore()

    const user = await axios.patch(`${store2.host}/api/v1/clients-auth/change-password`,{
      id:store.user.id,
      ...data
    })

    user.data.data.formalPersonalPhoto = `${store2.host}/${user.data.data.formalPersonalPhoto}`

    await localStorage.setItem('user', JSON.stringify(user.data.data));
    store.user = await user.data.data
    await Loading.hide()
    Notify.create({
      type:"positive",
      message:"تم تغير كلمة المرور بنجاح"
    })
    //await router.push("/home")
  }
  catch (e) {
    await Loading.hide()
    Notify.create({
      type:"negative",
      message:"كلمة المرور السابقة غير صحيحة"
    })
    localStorage.removeItem("user")
    console.log(e.response.data.message)
  }

}

